import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../useAxios";
import { useTranslation } from "react-i18next";
import { EmailTemplate } from "@types";
import { App } from "antd";

export const useEditEmailTemplate = () => {
  const axios = useAxios();
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { message } = App.useApp();

  const editEmailTemplate = async (emailTemplate: EmailTemplate) => {
    try {
      const response = await axios.put(
        `/api/emailtemplates/${emailTemplate.id}`,
        emailTemplate
      );
      return response.data;
    } catch (error) {
      throw new Error(t("messages.error.editEmailTemplate"));
    }
  };

  return useMutation({
    mutationFn: editEmailTemplate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["emailTemplates"] });
      message.success(t("messages.success.editEmailTemplate"));
    },
  });
};